import { lazy } from "react";

// project imports
import MinimalLayout from "layout/MinimalLayout";
import NavMotion from "layout/NavMotion";
import Loadable from "ui-component/Loadable";
import Register from 'views/authentication/auth/Register';
import VerifyUser from 'views/authentication/auth/VerifyUser';
import RegistrationSuccessful from 'views/authentication/auth/Register-Success';
import CreateSecondaryUserPass from 'views/authentication/auth/createSecondaryUserPass';

// login routing
const AuthLogin = Loadable(
  lazy(() => import('views/authentication/auth/Login'))
);

const ConfomationVerification = Loadable(
  lazy(() => import('views/authentication/auth/ConformationEmail'))
);

const ForgotPassword = Loadable(
  lazy(() => import('views/authentication/auth/ForgotPassword'))
);

const ResetPassword = Loadable(
  lazy(() => import('views/authentication/auth/ResetPassword'))
);
const ConfirmChangePassword = Loadable(
  lazy(() => import('views/changePassword'))
);
const ChangePassword = Loadable(
  lazy(() => import('views/changePassword/changePasswordModel'))
);

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: (
    <NavMotion>
      <MinimalLayout />
    </NavMotion>
  ),
  children: [
    {
      path: '/',
      element: <AuthLogin />,
    },
    {
      path: '/login',
      element: <AuthLogin />,
    },
    {
      path: '/register',
      element: <Register />,
    },
    {
      path: '/verify-user',
      element: <VerifyUser />,
    },
    {
      path: '/forgot',
      element: <ForgotPassword />,
    },
    {
      path: '/resetPassword',
      element: <ResetPassword />,
    },
    {
      path: '/registration-success',
      element: <RegistrationSuccessful />,
    },
    {
      path: '/createSecondaryUserPassword/:id',
      element: <CreateSecondaryUserPass />,
    },
    {
      path: '/confirm-change-password',
      element: <ConfirmChangePassword />,
    },
    {
      path: '/change-password',
      element: <ChangePassword />,
    },
    {
      path: '/activateBusinessPartnerUsers/:token',
      element: <ConfomationVerification />,
    },
  ],
};

export default LoginRoutes;
